export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7197.00da60ea.jpg";